import RightArrowDecal from '@/components/RightArrowDecal';

import NoFeesIcon from 'svgs/redesign/whyNoFees.svg';
import PersonIcon from 'svgs/redesign/whyPerson.svg';
import SearchIcon from 'svgs/redesign/whySearch.svg';

import WhyIcon from 'svgs/redesign/why.svg';

import * as styles from './index.module.scss';

const PANELS = [
  {
    Icon: SearchIcon,
    headline: 'Quality leads',
    copy: 'Our technology ensures that only qualified homeowners are calling you.'
  },
  {
    Icon: NoFeesIcon,
    headline: 'No set up fees',
    copy: 'You set the budget, you set the prices. You have full control. There&apos;s no committment.'
  },
  {
    Icon: PersonIcon,
    headline: 'Support',
    copy: 'Our support is unmatched. We want you to get the most out of your account. We&apos;ll help you get set up and we&apos;ll help you optimize your account.'
  }
];

const WhoWeAreSignup = () => (
  <div className={styles['who-we-are-container']}>
    <RightArrowDecal />
    <div className={`${styles['container']} container`}>
      <div className={styles['headline-container']}>
        <h2>Why CallAPro?</h2>
        <p>Thousands of service pros rely on us to help them grow their business.</p>
      </div>
      <div className={styles['content-container']}>
        <div className={styles['image-container']}>
          <WhyIcon />
        </div>
        <div className={styles['panels-container']}>
          {PANELS.map((panel) => (
            <div key={panel.headline} className={styles['panel']}>
              <div className={styles['headline']}>
                <panel.Icon />
                <h4 dangerouslySetInnerHTML={{ __html: panel.headline }} />
              </div>
              <p className={styles['copy']} dangerouslySetInnerHTML={{ __html: panel.copy }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default WhoWeAreSignup;
